import React, { ReactElement } from "react";

import { Summary } from "affinityUI/data/summary";
import { Address, DoB, NhsNumber, PatientConsent, PreferredContact } from "affinityUI/data/valueDisplay";
import { Card } from "affinityUI/elements/card";
import { Grid } from "affinityUI/elements/grid";
import type { PatientData } from "types/patient";

import { DeviceInfo } from "../deviceSection";

const cols = { xs: [1], lg: [2, 1] };
export const PatientDetails: React.FC<{ patient: PatientData; detailsActions?: Maybe<ReactElement> }> = ({
  detailsActions,
  patient,
}) => {
  return (
    <>
      <Grid $cols={cols}>
        <Card $tight>
          <Summary.Section title="Patient Details" actions={detailsActions}>
            <Grid $cols={[1, 1]}>
              <Summary.List $tight>
                <Summary.Item label="DOB:">
                  <DoB value={patient.dateOfBirth} />
                </Summary.Item>
                <Summary.Item label="Hospital number:">{patient.hospitalNumber}</Summary.Item>
                <Summary.Item label="NHS number:">
                  <NhsNumber value={patient.nhsNumber} />
                </Summary.Item>
                <Summary.Item label="Sex:">{patient.sex}</Summary.Item>
                <Summary.Item label="Patient ID:">{patient.id}</Summary.Item>
              </Summary.List>
              <Summary.List $tight>
                <Summary.Item label="Oncologist:">{patient.oncologist}</Summary.Item>
                <Summary.Item label="Primary:">
                  <address>{patient.contactDetails.primaryContact}</address>
                </Summary.Item>
                <Summary.Item label="Secondary:">
                  <address>{patient.contactDetails.secondaryContact}</address>
                </Summary.Item>
                <Summary.Item label="Email:">
                  <address>{patient.contactDetails.email}</address>
                </Summary.Item>
                <Summary.Item label="Contact preference:">
                  <PreferredContact value={patient.contactDetails.preferredContactMethod} />
                </Summary.Item>
                <Summary.Item label="Address:">
                  <Address value={patient.contactDetails.address} />
                </Summary.Item>
              </Summary.List>
            </Grid>
          </Summary.Section>
          <Summary.Section title="Patient Consent">
            <Grid $cols={[1]}>
              <Summary.List $tight>
                <Summary.Item label="Service:" hiddenLabel>
                  <PatientConsent
                    value={patient.consent.service}
                    consentType="service"
                    lastUpdated={
                      patient.consent.service === patient.consent.serviceLastUpdate[0]?.service
                        ? patient.consent.serviceLastUpdate[0]
                        : null
                    }
                  />
                </Summary.Item>
                <Summary.Item label="Privacy Policy:" hiddenLabel>
                  <PatientConsent
                    value={patient.consent.privacyPolicy}
                    consentType="privacyPolicy"
                    lastUpdated={
                      patient.consent.privacyPolicy === patient.consent.privacyPolicyLastUpdate[0]?.privacyPolicy
                        ? patient.consent.privacyPolicyLastUpdate[0]
                        : null
                    }
                  />
                </Summary.Item>
                <Summary.Item label="Feedback:" hiddenLabel>
                  <PatientConsent
                    value={patient.consent.feedback}
                    consentType="feedback"
                    lastUpdated={
                      patient.consent.feedback === patient.consent.feedbackLastUpdate[0]?.feedback
                        ? patient.consent.feedbackLastUpdate[0]
                        : null
                    }
                  />
                </Summary.Item>
              </Summary.List>
            </Grid>
          </Summary.Section>
        </Card>
        <Card $tight>
          <Summary.List>
            <Summary.Section title="Device Details">
              <DeviceInfo patient={patient} />
            </Summary.Section>
          </Summary.List>
        </Card>
      </Grid>
    </>
  );
};
